export default {
  name: 'status',
  translationKey: 'status-module',
  routePrefix: 'status',
  routeNamePrefix: 'admin.status',
  directRoutesAvailable: false,
}
